module.exports = __webpack_public_path__ + "img/intercom.8604acc1.svg";